/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FolderClock = [
  "svg",
  defaultAttributes,
  [
    ["circle", { cx: "16", cy: "16", r: "6" }],
    [
      "path",
      {
        d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2"
      }
    ],
    ["path", { d: "M16 14v2l1 1" }]
  ]
];

export { FolderClock as default };
//# sourceMappingURL=folder-clock.js.map
